import React from 'react';
import { Hero } from '../components/landing/Hero';
import { ProblemSection } from '../components/landing/ProblemSection';
import { ResearchSection } from '../components/landing/ResearchSection';
import { Ingredients } from '../components/landing/Ingredients';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Testimonials } from '../components/landing/Testimonials';
import { DoctorProfile } from '../components/landing/DoctorProfile';
import { Pricing } from '../components/landing/Pricing';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen font-sans text-slate-900 bg-white selection:bg-emerald-100 selection:text-emerald-900" data-id="element-299">
      <Hero data-id="element-300" />
      <ProblemSection data-id="element-301" />
      <ResearchSection data-id="element-302" />
      <Ingredients data-id="element-303" />
      <HowItWorks data-id="element-304" />
      <Testimonials data-id="element-305" />
      <DoctorProfile data-id="element-306" />
      <Pricing data-id="element-307" />
      <Footer data-id="element-308" />
    </div>;
}